module.exports = __webpack_public_path__ + "fonts/OpenSans-Bold.6e27168.ttf";